type Treatment = {
  treatment: string;
  quantity: number;
  price: number;
};
const initialState = {
  printPosition: {
    container: {
      top: 570,
      left: 604,
      show: true,
      size: 50,
      title: "container",
      name: "container",
    },
    logo: {
      top: 10,
      left: 10,
      show: true,
      size: 50,
      title: "logo",
      name: "clinic Logo",
    },
    headerImage: {
      top: 0,
      left: 0,
      show: false,
      title: "headerImage",
      name: "clinic Header Image",
      height: 150,
      width: 604,
    },
    footerImage: {
      top: 500,
      left: 0,
      show: false,
      title: "footerImage",
      name: "clinic Footer Image",
      height: 50,
      width: 604,
    },
    header: {
      top: 20,
      left: 80,
      show: true,
      size: 20,
      title: "header",
      name: "Title",
    },
    invoiceNotext: {
      top: 20,
      left: 330,
      show: true,
      size: 13,
      title: "invoiceNotext",
      name: "Invoice Number Title",
    },
    invoiceNo: {
      top: 20,
      left: 430,
      show: true,
      size: 13,
      title: "invoiceNo",
      name: "Invoice Number",
    },
    datetimetext: {
      top: 40,
      left: 330,
      show: true,
      size: 13,
      title: "datetimetext",
      name: "Date Time Title",
    },
    datetime: {
      top: 40,
      left: 430,
      show: true,
      size: 13,
      title: "datetime",
      name: "Date Time",
    },
    regNotext: {
      top: 60,
      left: 330,
      show: true,
      size: 13,
      title: "regNotext",
      name: "Register Number Title",
    },
    regNo: {
      top: 60,
      left: 430,
      show: true,
      size: 13,
      title: "regNo",
      name: "Register Number",
    },
    patientNametext: {
      top: 96,
      left: 14,
      show: true,
      size: 13,
      title: "patientNametext",
      name: "Patient Name Title",
    },
    patientName: {
      top: 96,
      left: 140,
      show: true,
      size: 13,
      title: "patientName",
      name: "Patient Name",
    },
    agetext: {
      top: 80,
      left: 14,
      show: true,
      size: 13,
      title: "agetext",
      name: "age Title",
    },
    age: {
      top: 80,
      left: 140,
      show: true,
      size: 13,
      title: "age",
      name: "age Name",
    },
    contactNotext: {
      top: 96,
      left: 225,
      show: true,
      size: 13,
      title: "contactNotext",
      name: "Contact Number Title",
    },
    contactNo: {
      top: 96,
      left: 350,
      show: true,
      size: 13,
      title: "contactNo",
      name: "Contact Number",
    },
    gendertext: {
      top: 96,
      left: 465,
      show: true,
      size: 13,
      title: "gendertext",
      name: "Gender Title",
    },
    gender: {
      top: 96,
      left: 525,
      show: true,
      size: 13,
      title: "gender",
      name: "Gender",
    },
    horizontallineone: {
      top: 105,
      left: 10,
      show: true,
      size: 550,
      title: "horizontallineone",
      name: "Horizondal Line One",
    },
    horizontallinetwo: {
      top: 520,
      left: 10,
      show: true,
      size: 550,
      title: "horizontallinetwo",
      name: "Horizondal Line two",
    },
    treatmentDetail: {
      top: 125,
      left: 10,
      show: true,
      size: 550,
      title: "treatmentDetail",
      name: "Treatment Details",
    },
    billDetails: {
      top: 270,
      left: 10,
      show: true,
      size: 550,
      title: "billDetails",
      name: "Bill Details",
    },
    addresstext: {
      top: 540,
      left: 15,
      show: true,
      size: 13,
      title: "addresstext",
      name: "Address Title",
    },
    address: {
      top: 540,
      left: 75,
      show: true,
      size: 13,
      title: "address",
      name: "Address",
    },
    teltext: {
      top: 540,
      left: 450,
      show: true,
      size: 13,
      title: "teltext",
      name: "Mobile Number Title",
    },
    tel: {
      top: 540,
      left: 480,
      show: true,
      size: 13,
      title: "tel",
      name: "Mobile Number",
    },
    dentisttext: {
      top: 540,
      left: 220,
      show: true,
      size: 13,
      title: "dentisttext",
      name: "dentist Name Title",
    },
    dentist: {
      top: 540,
      left: 325,
      show: true,
      size: 13,
      title: "dentist",
      name: "dentist Name",
    },
  },
  clinic: {
    clinicName: "clinicName",
    tpNo: "0771234567",
    address: "0771234567",
    drName: "docto1 james",
    printImages: "12454",
    clinicTitle: "12454",
    headerImages: "12454",
    footerImages: "12454",
  },
  patient: {
    invoiceNo: "12454",
    regNo: "J/a1/2024",
    fullName: "user Name",
    mobileNo: "0771234567",
    gender: "female",
    invoiceDate: "2004-08-25T08:19:43.320+00:00",
    dob: "2004-08-25T08:19:43.320+00:00",
    createdAt: new Date(),
  },

  treatmentdata: [
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
  ],
  subTreatmentdata: [
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
    {
      treatment: "test",
      quantity: 2,
      price: 200,
    },
  ],
  amount: {
    total: 12454,
    lastDue: 12454,
    discount: 12454,
    netotal: 12454,
    card: 12454,
    cash: 12454,
    bankTransfer: 12454,
    longTermDue: 0,
    estimation: 0,
  },
  
};
type State = typeof initialState;
type PrintAction =  | {
  type: "SET_PRINTTEMPLATE2_ACTIONS";
  payload: {
    name: keyof State["printPosition"];
    target: keyof State["printPosition"][keyof State["printPosition"]];
    value: number | boolean | string;
  };
}
| {
  type: "SET_PRINTTEMPLATE2_CLINIC";
  payload: {
    name: string;
    value: number | boolean | string;
  };
}
| {
  type: "SET_PRINTTEMPLATE2_AMOUNT";
  payload: Partial<State["amount"]>;
}
| {
  type: "SET_PRINTTEMPLATE2_TREATMENT";
  payload: Treatment[]; 
}
| {
  type: "SET_PRINTTEMPLATE2_SUB_TREATMENT";
  payload: Treatment[]; 
}
| {
  type: "SET_PRINTTEMPLATE2_PATIENT";
  payload: {
    name: string;
    value: number | boolean | string;
  };
};

export const printTemplate2Reducer = (state = initialState, action: PrintAction) => {
  switch (action.type) {
    case "SET_PRINTTEMPLATE2_ACTIONS": {
      const { name, target, value } = action.payload;
      if (!(name in state.printPosition)) return state;

      return {
        ...state,
        printPosition: {
          ...state.printPosition,
          [name]: {
            ...state.printPosition[name],
            [target]: value,
          },
        },
      };
    }
    case "SET_PRINTTEMPLATE2_CLINIC": {
      return {
        ...state,
        clinic: {
          ...state.clinic,
          ...action.payload
        },
      };
    }
    case "SET_PRINTTEMPLATE2_PATIENT": {
      return {
        ...state,
        patient: {
          ...state.patient,
          ...action.payload
        },
      };
    }
    case "SET_PRINTTEMPLATE2_AMOUNT": {
      return {
        ...state,
        amount: {
          ...state.amount,
          ...action.payload
        },
      };
    }
    case "SET_PRINTTEMPLATE2_TREATMENT": {
      return {
        ...state,
        treatmentdata: action.payload,
      };
    }
    case "SET_PRINTTEMPLATE2_SUB_TREATMENT": {
      return {
        ...state,
        subTreatmentdata: action.payload,
      };
    }

    default:
      return state;
  }
};
